import axios from 'axios';
import { useEffect, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Link, useLocation } from 'react-router-dom';
import { InternalBanner } from '../../components/internals/InternalBanner';
import { removeBaseUrl } from '../../utils';

import './styles.scss';
const Blog = () => {
    const [isFetching, setIsFetching] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [pageNo, setPageNo] = useState(1);
    const location = useLocation();
    const [hasMore, setHasMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [queryParam, setQueryParam] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
        document.title = 'Blogs - Medical Malpractice Lawyer NYC';
    }, []);

    useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const paramValue = queryParams.get('keyword');
      setQueryParam(paramValue);
      setBlogs([]);
      setPageNo(1);
    }, [location]);

    const fetchBlogs = async (pageNo, keyword, cat_id) => {
        if (isFetching) {
            return;
        }

        if (pageNo == 1) {
            setBlogs([]);
        }

        try {
            setIsFetching(true);
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=fetch_articles_by_pagination&paged=${pageNo}&keyword=${keyword}&category=${cat_id?cat_id:-1}`);
            setCurrentPage(Number(data?.paged));
            if (data?.result?.length > 0) {
                setBlogs([...blogs, ...data?.result]);
            }
            setHasMore(Number(data?.size) >= 9);
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        fetchBlogs(pageNo, '', selectedCategory);
    }, [pageNo]);

    useEffect(() => {
        fetchPageContent();
    }, []);

    const fetchPageContent = async () => {
        // setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=legal_blog`);
            console.log(data)
            if (data?.yoast_title?.length > 0) {
                document.title = data?.yoast_title;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title}` : "Blogs - Personal Injury Lawyers NYC - Medical Malpractice Lawyer NYC";
            }
        } catch (err) {
            console.log(err);
        } finally {
            // setIsFetchingPageData(false);
        }
    }

    const decodeHTML = (html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || '';
    }

    

    return  <Fade delay={1}>        
            <main id="main" className='internal-page'>
                <InternalBanner page={{ post_title: 'Legal Blog' }} />
                <section id="main-blogs-section" className='internal-page-section'>
                    <div className='container'>
                        <div className='page-content blog-content'>
                            <div className='blog-list'>
                                {
                                    blogs?.map((it, index) => <div className='article' key={index}>
                                        <img src={it?.featured_image} className="featured-image" />
                                        <div className='article-meta'>
                                            <span className='date'>{it?.post_date}</span>
                                            <Link to={removeBaseUrl(it?.link)} className='title'>{decodeHTML(it?.title)}</Link>
                                        </div>
                                    </div>)
                                }
                            </div>
                            {hasMore && <div className="read-more">
                                <span className="btn-load-more" data-page={currentPage + 1} onClick={()=>{
                                    setPageNo(currentPage + 1);
                                }} data-wpel-link="internal">
                                    Load more
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                        <mask id="mask0_762_478" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21">
                                            <rect x="21" width="21" height="21" transform="rotate(90 21 0)" fill="#D9D9D9"></rect>
                                        </mask>
                                        <g mask="url(#mask0_762_478)">
                                            <path d="M1.75 7.02188L3.30312 5.46875L10.5 12.6656L17.6969 5.46875L19.25 7.02188L10.5 15.7719L1.75 7.02188Z" fill="#001233"></path>
                                        </g>
                                    </svg>
                                </span>
                            </div>}
                        </div>
                    </div>
                </section>
            </main>
        </Fade>
}

export default Blog;